module.exports = __webpack_public_path__ + "static/media/white.d9bd8cea.svg";